// extracted by mini-css-extract-plugin
module.exports = {"sent":"ItemsTable_sent__1FQxl","link":"ItemsTable_link__2ZOBQ"};